<!-- Analytical toolbar: expand/collapse-all, export, print, saved view. -->
<div class="dd-toolbar" *ngIf="showToolbar">
  <button *ngIf="enableExpandCollapseAll" type="button" class="dd-btn" (click)="setAllExpanded(true)" title="Expand all rows">⤢ Expand all</button>
  <button *ngIf="enableExpandCollapseAll" type="button" class="dd-btn" (click)="setAllExpanded(false)" title="Collapse all rows">⤡ Collapse all</button>
  <span class="dd-toolbar-spacer"></span>
  <button *ngIf="enableSavedViews" type="button" class="dd-btn" (click)="saveView()" title="Save current expand/sort view">☆ Save view</button>
  <div class="dd-export-menu" *ngIf="enableExport || enableExcelExport || enablePdfExport || enablePrint">
    <details>
      <summary title="Export / print">⭳ Export</summary>
      <div class="dd-export-list">
        <button *ngIf="enableExport" type="button" class="dd-btn" (click)="exportCsv()">CSV</button>
        <button *ngIf="enableExcelExport" type="button" class="dd-btn" (click)="exportExcel()">Excel</button>
        <button *ngIf="enablePdfExport" type="button" class="dd-btn" (click)="exportPdf()">PDF</button>
        <button *ngIf="enablePrint" type="button" class="dd-btn" (click)="printTable()">Print</button>
      </div>
    </details>
  </div>
</div>

<!-- <div class="table-wrapper" style="overflow-x: auto"> -->
<ngx-datatable
  #table
  [style.width]="data?.tableWidth || null"
  class="material"
  [rows]="flattenedRows"
  [columns]="visibleColumns"
  [columnMode]="data?.columnMode || 'standard'"
  [headerHeight]="40"
  [footerHeight]="0"
  [rowHeight]="40"
  (activate)="onCellActivate($event)"
  [externalSorting]="true"
  (sort)="onSort($event)"
  (resize)="onColumnResize()"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [virtualization]="false"
>
  <!-- <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="footer-total-row">
          <div
            *ngFor="let col of visibleColumns"
            class="footer-cell"
            [style.width.px]="col.width"
          >
            <strong>
              {{
              col.prop === 'name' && col.levelIndex===0
              ? 'Total'
              : (col.prop && col.prop !== 'name' && grandTotalRow?.[col.prop] !== undefined && grandTotalRow?.[col.prop] !== null
              ? (col.type=='number' ? (grandTotalRow[col.prop] | number : "1.0-0") : (grandTotalRow[col.prop] | number : "1.1-1") +'%')
              : '')
              }}
            </strong>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-footer> -->

<div class="table-spinner-overlay" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<ng-template #percentageCell let-value="value">
  {{ value | number : "1.1-1" }}%
</ng-template>
<ng-template #numberCell let-value="value">
  {{ value | number : numberDigitsInfo }}
</ng-template>

<!-- Rich visual cell: data-bar / progress / heat-map / conditional / kpi /
     badge / trend / sparkline / icon — driven by data.visualRules[prop].kind. -->
<ng-template #visualCell let-value="value" let-row="row" let-column="column">
  <ng-container [ngSwitch]="row.isTotal ? 'plain' : visualKind(column.prop)">
    <!-- Data bar (value-scaled fill behind the number). -->
    <div *ngSwitchCase="'databar'" class="dd-databar-wrap">
      <span class="dd-databar" [style.width.%]="barWidth(column.prop, value)" [style.background]="barColor(column.prop)"></span>
      <span class="dd-databar-val">{{ value | number : numberDigitsInfo }}</span>
    </div>
    <!-- Progress bar (0..100). -->
    <div *ngSwitchCase="'progress'" class="dd-progress">
      <span class="dd-progress-fill" [style.width.%]="barWidth(column.prop, value)" [style.background]="barColor(column.prop)"></span>
      <span class="dd-progress-label">{{ value | number : "1.0-0" }}%</span>
    </div>
    <!-- Heat map (background scaled to column range). -->
    <div *ngSwitchCase="'heatmap'" class="dd-heat" [style.background]="cellBg(column.prop, value)">{{ value | number : numberDigitsInfo }}</div>
    <!-- Conditional formatting (bg/fg by rule). -->
    <div *ngSwitchCase="'conditional'" class="dd-cond" [style.background]="cellBg(column.prop, value)" [style.color]="cellFg(column.prop, value)">{{ value | number : numberDigitsInfo }}</div>
    <!-- KPI indicator / status badge. -->
    <span *ngSwitchCase="'kpi'" class="dd-badge" [ngClass]="badgeFor(column.prop, value)?.cls">{{ badgeFor(column.prop, value)?.text }}</span>
    <span *ngSwitchCase="'badge'" class="dd-badge" [ngClass]="badgeFor(column.prop, value)?.cls">{{ badgeFor(column.prop, value)?.text }}</span>
    <!-- Trend indicator (arrow + value). -->
    <span *ngSwitchCase="'trend'" class="dd-trend" [ngClass]="trendFor(value).cls">{{ trendFor(value).icon }} {{ value | number : numberDigitsInfo }}</span>
    <!-- Sparkline (mini line chart from an array cell). -->
    <svg *ngSwitchCase="'sparkline'" class="dd-spark" width="60" height="18" viewBox="0 0 60 18" preserveAspectRatio="none">
      <polyline [attr.points]="sparkPoints(value)" fill="none" [attr.stroke]="barColor(column.prop)" stroke-width="1.5" />
    </svg>
    <!-- Mini bar chart (from an array cell). -->
    <svg *ngSwitchCase="'minibar'" class="dd-spark" width="60" height="18" viewBox="0 0 60 18">
      <rect *ngFor="let b of sparkBars(value)" [attr.x]="b.x" [attr.y]="18 - b.h" [attr.width]="b.w" [attr.height]="b.h" [attr.fill]="barColor(column.prop)" />
    </svg>
    <!-- Icon / color-coded dot. -->
    <span *ngSwitchCase="'icon'" class="dd-iconcell"><span class="dd-dot" [style.background]="cellBg(column.prop, value) || barColor(column.prop)"></span>{{ value | number : numberDigitsInfo }}</span>
    <!-- Plain number (fallback / total rows). -->
    <ng-container *ngSwitchDefault>{{ value | number : numberDigitsInfo }}</ng-container>
  </ng-container>
</ng-template>
<ng-template
  #treeCell
  let-row="row"
  let-rowIndex="rowIndex"
  let-columnIndex="columnIndex"
  let-value="value"
  let-column="column"
>
  <div
    *ngIf="row.isTotal && (column.indentByLevel || row.level === column.levelIndex + 1)"
    style="font-weight: bold; color: #444"
    [style.padding-left.px]="column.indentByLevel ? (row.level - 1) * 18 : 0"
  >
    {{ row[nameProp] }}
  </div>

  <div
    *ngIf="!row.isTotal && (column.indentByLevel || row.level === column.levelIndex + 1)"
    style="display: flex; align-items: center; justify-content: space-between"
    [style.padding-left.px]="column.indentByLevel ? (row.level - 1) * 18 : 0"
    [ngClass]="{
      'highlight-cell': highlightedCells.includes(rowIndex + '-' + column.prop)
    }"
  >
    <div style="display: flex; align-items: center; gap: 4px; cursor: pointer">
      <mat-icon
        (click)="toggleExpand(row); $event.stopPropagation()"
        *ngIf="row.children?.length"
        style="
          font-size: calc(18px * var(--dvm-font-scale, 1));
          line-height: 1;
          display: flex;
          align-items: center;
        "
      >
        {{ row.expanded ? "remove_circle_outline" : "add_circle_outline" }}
      </mat-icon>

      <div
        style="
          font-weight: bold;
          color: #444;
          display: flex;
          align-items: center;
        "
      >
        {{ row[nameProp] }}
      </div>
    </div>

    <mat-icon
      (click)="$event.stopPropagation()"
      *ngIf="hasNavigation(column.levelIndex)"
      [matMenuTriggerFor]="menu"
      >more_vert</mat-icon
    >
  </div>
  <mat-menu #menu="matMenu">
    <ng-container *ngFor="let navItem of data.navigation">
      <button
        mat-menu-item
        *ngIf="column.levelIndex === navItem.level"
        (click)="onNavigate(navItem, row)"
      >
        {{ navItem.name }}
      </button>
    </ng-container>
  </mat-menu>
</ng-template>

<ng-template #infoIconHeader let-column="column">
  <div
    style="display: flex; align-items: center; flex-grow: 1"
    [ngClass]="'justify-' + column.alignment"
  >
    <span [title]="column.name">{{ column.name }}</span>
    <mat-icon
      *ngIf="column.infoIcon"
      [matTooltip]="column.infoText"
      class="info-icon"
      >info_outline</mat-icon
    >
  </div>
</ng-template>
</ngx-datatable>


<!-- Sticky total row -->

<!-- Sticky total row -->
<div class="sticky-total-row" #totalRow>
  <div
    *ngFor="let col of visibleColumns; let i = index"
    class="total-cell"
    [class.total-cell-fixed]="col.prop === nameProp && col.levelIndex === 0"
    [ngStyle]="totalCellStyle(i, col)"
  >
    <strong>
              {{
              col.prop === nameProp && col.levelIndex===0
              ? 'Total'
              : (col.prop && col.prop !== nameProp && grandTotalRow?.[col.prop] !== undefined && grandTotalRow?.[col.prop] !== null
              ? (col.type=='number' ? (grandTotalRow[col.prop] | number : "1.0-0") : (grandTotalRow[col.prop] | number : "1.1-1") +'%')
              : '')
              }}
            </strong>
  </div>
</div>

<!-- </div> -->
